import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormUpdate = createAsyncThunk(
    'formUpdate/fetchFormUpdate',
    async ({ id, file, title, slug, description, content, formGroupId }) => {
        const response = await FormUpdateService(id, file, title, slug, description, content, formGroupId)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const formUpdateSlice = createSlice({
    name: 'formUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formUpdateSlice.reducer;
